import { icons, LucideProps } from "lucide-react";

export type IconName = keyof typeof icons;

interface IconProps extends Omit<LucideProps, "color"> {
	name: IconName;
	color?: string | null;
}

const Icon: React.FC<IconProps> = ({ name, color, ...props }) => {
	const DynamicIcon = icons[name];

	if (!DynamicIcon) return <></>;

	const style = color
		? {
				...props.style,
				color: `var(--tc-${color})`,
			}
		: props.style;

	return <DynamicIcon {...props} style={style} />;
};

export default Icon;
